import React from 'react';
import Select from '../../../shared/select';

const RegistrationCap = ({
  disabled,
  capOption,
  maxAttendees,
  onCapOptionsChange,
  onMaxAttendeesChange,
}) => (
  <div className="EventSessionForm-field d-f ai-fe">
    <div className="f-sh-0">
      <div className="f-sh-0">
        <label htmlFor="cap-options">
          {t('in_person_training.new_event.registration_cap')}
        </label>
        <div className="f-sh-0">
          <Select
            fullWidth
            onChange={onCapOptionsChange}
            value={capOption}
            id="cap-options"
            disabled={disabled}
            ariaLabel="Registration Cap"
          >
            <option value="false">{t('common.no')}</option>
            <option value="true">{t('common.yes')}</option>
          </Select>
        </div>
      </div>
    </div>
    {capOption && (
      <>
        <input
          type="number"
          min="1"
          step="1"
          name="maxAttendees"
          className="NewInput NewInput--white w-101 ml-8 mr-8"
          id="max-attendees"
          onChange={onMaxAttendeesChange}
          value={maxAttendees}
          required={capOption}
          disabled={disabled}
        />
        <label htmlFor="max-attendees">
          * {t('in_person_training.new_event.no_of_people')}
        </label>
      </>
    )}
  </div>
);

export default RegistrationCap;
